import * as EthWatchExports from './exports'
Object.assign(EthWatchExports.EthWatch, EthWatchExports)
export default EthWatchExports.EthWatch
